module.exports = __webpack_public_path__ + "media/images/emblems/Moudon-coat_of_arms-fd2675653c203598513f8d8d673d6a20.svg";